/**
 * Google Analytics 4 event helpers.
 * Tracks conversion-critical events on the landing page.
 */
export const track = (event, params = {}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  try {
    window.gtag("event", event, params);
  } catch (err) {
    // Never block the user action, but surface in development.
    if (process.env.NODE_ENV !== "production") {
      console.error("[analytics] gtag failed:", err);
    }
  }
};

export const trackWhatsApp = (location) =>
  track("whatsapp_click", { location, channel: "whatsapp" });

export const trackCalendar = (location) =>
  track("calendar_click", { location, channel: "google_calendar" });

export const trackEmail = (location) =>
  track("email_click", { location, channel: "email" });

export const trackPhone = (location) =>
  track("phone_click", { location, channel: "phone" });

export const trackLeadSubmit = (params = {}) => {
  track("lead_submit", { ...params, channel: "form" });
  track("generate_lead", { ...params, channel: "form", page: "homepage" });
};

export const trackLanguage = (lang) =>
  track("language_toggle", { language: lang });

export const trackSimulator = (action, params = {}) =>
  track("simulator", { action, ...params });
